import { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
import { getMUICache, getUrl, getSocialClassName, getEndpoint, getImageId, getImageUrl, getImageSize, setCmsSeoData, GetIconsSprites } from
    './../../common/utils';
import './AuthorShow.css';
import bcrypt from 'bcryptjs-react';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../components/IntersectionObserver/imageComponent';

AuthorShow.version = 1000;

AuthorShow.lang = 'en';
AuthorShow.langs = [
    'en'
];
AuthorShow.setLang = (lang: any) => {
    AuthorShow.lang = lang;
}

Object.defineProperty(AuthorShow, 'name', {
    writable: true,
    value: 'AuthorShow'
});

export function AuthorShow(props: any) {
    AddImageDimensions();
    SetHighPriorityImages();
    PreloadViewportImages();
    ImageLoader();

    useEffect(() => {
        EagerLoadImages();
    }, []);
    const cache = getMUICache();
    const [authorData, setAuthorData] = useState<any>({});
    const { showSocialIcon, showDepartment, showViewport } = props;
    const endpoint = getEndpoint(props, "MAIN");

    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, []);

    if (endpoint.isSSR && endpoint.SSRDataObj
        && authorData && Object.keys(authorData).length === 0 && endpoint.SSRDataObj.response.author && endpoint.SSRDataObj.response.author.length > 0) {
        setAuthorData(endpoint.SSRDataObj.response.author[0]);
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
            && endpoint.SSRDataObj.response.author.length > 0) {
            props.exportedKeys.authorid = endpoint.SSRDataObj.response.author[0].id;
        }
        setCmsSeoData(props, endpoint.SSRDataObj.response.author[0], "AuthorShow");
    }

    const fetchComponentData = () => {
        let cardUrl = getUrl(props, 0, false, "MAIN", true);

        let headerString = '?' + cardUrl.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(cardUrl, { headers: headers })
            .then(data => data.json())
            .then(val => {
                if (val.response.author && val.response.author.length > 0) {
                    setAuthorData(val.response.author[0])
                    if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
                        && val.response.author.length > 0) {
                        props.exportedKeys.authorid = val.response.author[0].id;
                    }
                    setCmsSeoData(props, val.response.author[0], "AuthorShow");
                }
            })
    }


    const getSocialMediaIcons = () => {
        const { socialmediaprofile } = authorData;
        let result = [];

        console.log('socialmediaprofile', socialmediaprofile)
        for (let key in socialmediaprofile) {
            if (key != "hostid") {
                const iconType = getSocialClassName(key, 1, 'author');
                result.push(<li>
                    <a className="toTwitter" href={socialmediaprofile[key]} target="_self">
                        {/* <FdontAwesomeIcon icon={getSocialClassName(key)} /> */}
                        <div className={`sprite-icon ${iconType}`} style={{ backgroundImage: `url(${GetIconsSprites()})` }} />
                    </a>
                </li>)
            }
        }

        return result;
    }

    const getAuthorLink = () => {
        if (typeof authorData?.pubInfo != "undefined" && authorData?.pubInfo != null) {
            const { pubInfo, personalprofile, id } = authorData;
            let url = pubInfo.baseDomain;
            let finalUrl = `${url}${personalprofile.seoname}/author/${id}.html`;
            if (!url) finalUrl = `/${finalUrl}`;
            return finalUrl;
        }
    }

    return (
        <div className='commoncontainer'>
            <CacheProvider value={cache}>
                <Grid item md={12} xs={12}>
                    <div className='authorbiowrap'>
                        <div className='authorbioimagewrap'>
                            <div className='authorbioimage'>
                                <div className="manageimagewrap">
                                    {authorData && Object.keys(authorData).length && getImageSize(authorData.imageid) &&
                                        (<picture>
                                            <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(authorData.imageid), getImageSize(authorData.imageid), 290, 218, authorData && authorData.pubInfo.baseDomain, true, props.CONSTANTS, '8')} />
                                            <source media="(min-width: 320px)" srcSet={getImageUrl(getImageId(authorData.imageid), getImageSize(authorData.imageid), 328, 246, authorData && authorData.pubInfo.baseDomain, true, props.CONSTANTS, '8')} />
                                            {/* Fallback image for browsers that do not support the picture element */}
                                            {showViewport ? (<img alt={authorData?.name} title={authorData?.name} loading="lazy"/>)
                                                : (<img  alt={authorData?.name} title={authorData?.name} loading="lazy"/>)}
                                        </picture>)
                                    }
                                    <div className="author__info for-mobile">
                                        <div className='authormainbio'>
                                            <a className="author_name" href={getAuthorLink()} target="_self">{authorData && authorData.name}</a>
                                        </div>


                                        <div className="authornewrap">
                                            {showDepartment && <span className='authorreport authorreport-desktop'>{authorData && authorData.professionalprofile &&
                                                authorData.professionalprofile.authortype}</span>}

                                            {showSocialIcon && authorData && authorData.socialmediaprofile &&

                                                <ul className="author-social-icon">
                                                    {getSocialMediaIcons()}
                                                </ul>
                                            }

                                        </div>
                                    </div>

                                </div>

                            </div>

                            <div className='manageauthordiv'>
                                <div className="author__info for-desktop">
                                    <div className='authormainbio'>
                                        <a className="author_name" href={getAuthorLink()} target="_self">{authorData && authorData.name}</a>
                                    </div>


                                    <div className="authornewrap">
                                        {showDepartment && <span className='authorreport authorreport-desktop'>{authorData && authorData.professionalprofile &&
                                            authorData.professionalprofile.authortype}</span>}

                                        {showSocialIcon && authorData && authorData.socialmediaprofile &&

                                            <ul className="author-social-icon">
                                                {getSocialMediaIcons()}
                                            </ul>
                                        }

                                    </div>
                                </div>
                                {authorData && authorData.personalprofile &&
                                    <p dangerouslySetInnerHTML={{ __html: authorData.personalprofile.bio }} />}
                            </div>
                        </div>
                    </div>
                    <div className='clearfix'></div>
                </Grid>
            </CacheProvider>
        </div>
    )
}